// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"54a701b1","567":"965d27b9","631":"8a4ec1cb","706":"a3ebc83f"}[chunkId] + ".chunk.css";
};